import "./newsletter.css";
import API_BASE_URL from "../../../config/api";
import { Newspaper, Envelope, XLg } from "react-bootstrap-icons";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAuth } from "../../../hooks/AuthProvider";

const toolbarOptions = [
  [{ header: [1, 2, 3, false] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link"],
  ["clean"],
];

function Newsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [value, setValue] = useState("");
  const [file, setFile] = useState(null);
  const [sending, setSending] = useState(false);
  const subjectRef = useRef();
  const { token } = useAuth();

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/v1/newsletter`)
      .then((res) => setSubscribers(res.data || []))
      .catch((err) => console.error(err.message));
  }, []);

  const handleUnsubscribe = async (email) => {
    if (!window.confirm(`Unsubscribe ${email}?`)) return;
    try {
      await axios.post(`${API_BASE_URL}/api/v1/unsubscribe`, { email }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubscribers((prev) => prev.filter((s) => s.email !== email));
    } catch (err) {
      alert("Failed to unsubscribe");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value || value === "<p><br></p>") {
      alert("Message cannot be empty");
      return;
    }
    setSending(true);
    const unsubscribeHtml = `<br><hr><p style="font-size:12px;color:#888">If you no longer wish to receive these emails, <a href="${window.location.origin}/unsubscribe?email={{EMAIL}}">unsubscribe here</a>.</p>`;
    const formdata = new FormData();
    formdata.append("subject", subjectRef.current.value);
    formdata.append("message", value + unsubscribeHtml);
    if (file) formdata.append("attachment", file);
    try {
      const res = await axios.post(`${API_BASE_URL}/api/v1/sendnewsletter`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        alert("Newsletter sent successfully");
        subjectRef.current.value = "";
        setValue("");
        setFile(null);
      }
    } catch (err) {
      if (err.response?.status === 403) {
        alert("You do not have permission to send newsletters");
      } else {
        alert("Failed to send newsletter");
      }
    }
    setSending(false);
  };

  return (
    <div className="nlContent">
      <h3>Newsletter</h3>

      <div className="nlStat">
        <div className="nlStatIcon">
          <Envelope />
        </div>
        <div className="nlStatInfo">
          <h4>{subscribers.length}</h4>
          <p>Total Subscribers</p>
        </div>
      </div>

      <div className="nlSubscribers">
        <h4>Subscribers ({subscribers.length})</h4>
        {subscribers.length === 0 ? (
          <p className="text-muted p-3 m-0">No subscribers yet.</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Email</th>
                <th>Subscribed</th>
                <th style={{ width: 60 }}></th>
              </tr>
            </thead>
            <tbody>
              {subscribers.map((sub) => (
                <tr key={sub.id}>
                  <td>{sub.email}</td>
                  <td>{new Date(sub.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="blogDeleteBtn"
                      onClick={() => handleUnsubscribe(sub.email)}
                      title="Unsubscribe"
                    >
                      <XLg />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <form className="nlForm" onSubmit={handleSubmit}>
        <h4>
          <Newspaper className="me-2" />
          Send Newsletter
        </h4>

        <label>Subject</label>
        <input
          className="nlSubjectInput"
          type="text"
          ref={subjectRef}
          placeholder="Email subject..."
          required
        />

        <label>Cover Image (optional)</label>
        <div
          className="nlFileArea"
          onClick={() => document.getElementById("nlFileInput").click()}
        >
          <input
            id="nlFileInput"
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => setFile(e.target.files[0])}
          />
          <p>{file ? file.name : "Click to add or drag and drop image"}</p>
        </div>

        <label>Message</label>
        <ReactQuill
          theme="snow"
          value={value}
          onChange={setValue}
          modules={{ toolbar: toolbarOptions }}
          style={{ height: 300, marginBottom: 60 }}
        />

        <div className="nlActions">
          <button
            type="button"
            className="nlCancelBtn"
            onClick={() => { subjectRef.current.value = ""; setValue(""); setFile(null); }}
          >
            Clear
          </button>
          <button className="nlSendBtn" type="submit" disabled={sending}>
            {sending ? "Sending..." : "Send Newsletter"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Newsletter;
